var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.41 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 10",
    d: "M0 10.59L4.58 6 0 1.41 1.41 0l6 6-6 6z",
    fill: "#001c4a"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3LjQxIDEyIj48cGF0aCBkYXRhLW5hbWU9IkNhbWluaG8gMTAiIGQ9Ik0wIDEwLjU5TDQuNTggNiAwIDEuNDEgMS40MSAwbDYgNi02IDZ6IiBmaWxsPSIjMDAxYzRhIi8+PC9zdmc+";
export { SvgArrowRight as ReactComponent };